package com.sddamico.draftmachine

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.SideEffect
import com.sddamico.draftmachine.ds.motion.installMotionStyles
import com.sddamico.draftmachine.util.installHistoryTransitions
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.core.init.InitKobweb
import com.varabyte.kobweb.core.init.InitKobwebContext
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.vh
import org.w3c.dom.HTMLHtmlElement
import kotlinx.browser.document

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.DARK
}

@InitKobweb
fun initKobweb(ctx: InitKobwebContext) {
  installMotionStyles()
  installHistoryTransitions()
    ctx.router.setErrorPage {
        val pageCtx = rememberPageContext()
        LaunchedEffect(Unit) {
            pageCtx.router.tryRoutingTo("/")
        }
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SideEffect {
        (document.documentElement as? HTMLHtmlElement)?.classList?.remove("dm-auth-pending")
    }
    SilkApp {
        Surface(SmoothColorStyle.toModifier().minHeight(100.vh)) {
            content()
        }
    }
}
